/* Polsk katalog for locale-autopilot-sales.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'ap.agent.sales.title': 'Faktury i oferty',
  'ap.agent.sales.pending': 'Niewysłane dokumenty: {{count}}.',
  'ap.agent.sales.detail': 'Wyślij gotowe faktury i oferty. Szkice trzeba dokończyć na liście faktur.',
  'ap.agent.sales.draft': 'Szkic',
  'ap.agent.sales.invoices': 'Faktury',
  'ap.agent.sales.drafts': 'Szkice',
  'ap.agent.sales.offers': 'Oferty',
  'ap.agent.offer.sendSelected': 'Wyślij wybrane oferty ({{count}})',
  'ap.agent.sales.sentCount': 'Wysłane oferty: {{count}}',
  'ap.agent.sales.send': 'Wyślij',
  'ap.agent.sales.open': 'Otwórz',
  'ap.agent.sales.empty': 'Brak niewysłanych dokumentów na tej liście.',
  'ap.agent.sales.unavailable': 'Nie można wysłać dokumentu. Otwórz listę faktur, aby sprawdzić status.',
  'ap.agent.sales.emailMissing': 'Klient nie ma adresu e-mail. Dodaj go na liście faktur przed wysłaniem.',
  'ap.agent.sales.sendFailed': 'Dokument nie został wysłany. Spróbuj ponownie z listy faktur.',
});
